import { useMutation } from "@tanstack/react-query";
import { useAxiosProvider } from "../providers/axios-provider.js";
import "react/jsx-runtime";
import "react";
import "axios";
const cancelAppointment = (axios) => async (id = "", params) => {
  const { data } = await axios.patch(`/api/v1/internal/appointments/${id}`, params);
  return data;
};
const useCancelAppointment = ({ id }) => {
  const { echoCore } = useAxiosProvider();
  const mutation = useMutation({
    mutationFn: ({ data }) => {
      const { cancellationType, reason, transferToOpenAppointment } = data;
      const props = {
        cancellationType,
        transferToOpenAppointment,
        reason
      };
      return cancelAppointment(echoCore)(id, props);
    }
  });
  return mutation;
};
export {
  useCancelAppointment
};
